import React from "react";
import { Row, Col } from 'reactstrap';

import CheckListProcessForm from '../../../check_list/process/form';

import { create, update } from './axios';

const AbstractCheckListProcessForm = props => {
  const {
    checkListProcess,
    currentCustomer,
    currentEntityType,
    currentUser,
    data
  } = props;

  return(
    <Row>
      <Col md={12}>
        <CheckListProcessForm
          checkListProcess={ props?.checkListProcess }
          currentCustomer={ currentCustomer }
          currentUser={ currentUser }
          data={ data }
          configuration={{
            context: "abstract",
            defaultRequestParams: { current_entity_type_id: currentEntityType.hashid }
          }}
          services={{
            createService: create,
            updateService: update,
          }}
          routes={{
            showPath: Routes.abstract_check_list_process_path,
            indexPath: Routes.abstract_check_list_processes_path({ current_entity_type_id: currentEntityType.hashid })
          }}
        />
      </Col>
    </Row>
  )
};

export default AbstractCheckListProcessForm;
